import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=bf4c43d8&"
import script from "./MemberCenter.vue?vue&type=script&lang=js&"
export * from "./MemberCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MemberCenter.vue"
export default component.exports